
export const ORDER_UPDATE_START = 'ORDER_UPDATE_START';
export const ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS';
export const ORDER_UPDATE_ERROR = 'ORDER_UPDATE_ERROR';
export const ORDER_UPDATE_LOADING = 'ORDER_UPDATE_LOADING';
export const ORDER_UPDATE_CANCEL = 'ORDER_UPDATE_CANCEL';

export const RESIN_ORDER_UPDATE_START = 'RESIN_ORDER_UPDATE_START';
export const RESIN_ORDER_UPDATE_SUCCESS = 'RESIN_ORDER_UPDATE_SUCCESS';
export const RESIN_ORDER_UPDATE_ERROR = 'RESIN_ORDER_UPDATE_ERROR';
export const RESIN_ORDER_UPDATE_LOADING = 'RESIN_ORDER_UPDATE_LOADING';
export const RESIN_ORDER_UPDATE_CANCEL = 'RESIN_ORDER_UPDATE_CANCEL';

export const CANCEL_STOP_AUTO_RENEW_START = 'CANCEL_STOP_AUTO_RENEW_START';
export const CANCEL_STOP_AUTO_RENEW_SUCCESS = 'CANCEL_STOP_AUTO_RENEW_SUCCESS';
export const CANCEL_STOP_AUTO_RENEW_ERROR = 'CANCEL_STOP_AUTO_RENEW_ERROR';
export const CANCEL_STOP_AUTO_RENEW_LOADING = 'CANCEL_STOP_AUTO_RENEW_LOADING';
export const CANCEL_STOP_AUTO_RENEW_CANCEL = 'CANCEL_STOP_AUTO_RENEW_CANCEL';

export const RESIN_ORDER_REFUND_START = 'RESIN_ORDER_REFUND_START';
export const RESIN_ORDER_REFUND_SUCCESS = 'RESIN_ORDER_REFUND_SUCCESS';
export const RESIN_ORDER_REFUND_ERROR = 'RESIN_ORDER_REFUND_ERROR';
export const RESIN_ORDER_REFUND_LOADING = 'RESIN_ORDER_REFUND_LOADING';
export const RESIN_ORDER_REFUND_CANCEL = 'RESIN_ORDER_REFUND_CANCEL';

export type Actions = {
    ORDER_UPDATE_START: { type: typeof ORDER_UPDATE_START, payload: any },
    ORDER_UPDATE_LOADING: { type: typeof ORDER_UPDATE_LOADING, payload: boolean },
    ORDER_UPDATE_SUCCESS: { type: typeof ORDER_UPDATE_SUCCESS, payload: any },
    ORDER_UPDATE_ERROR: { type: typeof ORDER_UPDATE_ERROR, payload: any },
    ORDER_UPDATE_CANCEL: { type: typeof ORDER_UPDATE_CANCEL, payload: any },
    RESIN_ORDER_UPDATE_START: { type: typeof RESIN_ORDER_UPDATE_START, payload: any },
    RESIN_ORDER_UPDATE_LOADING: { type: typeof RESIN_ORDER_UPDATE_LOADING, payload: boolean },
    RESIN_ORDER_UPDATE_SUCCESS: { type: typeof RESIN_ORDER_UPDATE_SUCCESS, payload: any },
    RESIN_ORDER_UPDATE_ERROR: { type: typeof RESIN_ORDER_UPDATE_ERROR, payload: any },
    RESIN_ORDER_UPDATE_CANCEL: { type: typeof RESIN_ORDER_UPDATE_CANCEL, payload: any },
    CANCEL_STOP_AUTO_RENEW_START: { type: typeof CANCEL_STOP_AUTO_RENEW_START; payload: boolean };
    CANCEL_STOP_AUTO_RENEW_LOADING: { type: typeof CANCEL_STOP_AUTO_RENEW_LOADING; payload: boolean };
    CANCEL_STOP_AUTO_RENEW_SUCCESS: { type: typeof CANCEL_STOP_AUTO_RENEW_SUCCESS; payload: any };
    CANCEL_STOP_AUTO_RENEW_ERROR: { type: typeof CANCEL_STOP_AUTO_RENEW_ERROR; payload: any };
    CANCEL_STOP_AUTO_RENEW_CANCEL: { type: typeof CANCEL_STOP_AUTO_RENEW_CANCEL; payload: any };
    RESIN_ORDER_REFUND_START: { type: typeof RESIN_ORDER_REFUND_START, payload: any },
    RESIN_ORDER_REFUND_LOADING: { type: typeof RESIN_ORDER_REFUND_LOADING, payload: boolean },
    RESIN_ORDER_REFUND_SUCCESS: { type: typeof RESIN_ORDER_REFUND_SUCCESS, payload: any },
    RESIN_ORDER_REFUND_ERROR: { type: typeof RESIN_ORDER_REFUND_ERROR, payload: any },
    RESIN_ORDER_REFUND_CANCEL: { type: typeof RESIN_ORDER_REFUND_CANCEL, payload: any },
    };
// Action Creators
export const actionCreators = {
  orderUpdateStart: (payload: any): Actions[typeof ORDER_UPDATE_START] => ({
    type: ORDER_UPDATE_START, payload,
  }),
  orderUpdateError: (payload: any): Actions[typeof ORDER_UPDATE_ERROR] => ({
    type: ORDER_UPDATE_ERROR, payload,
  }),
  orderUpdateSuccess: (payload: any): Actions[typeof ORDER_UPDATE_SUCCESS] => ({
    type: ORDER_UPDATE_SUCCESS, payload,
  }),
  orderUpdateLoading: (payload: boolean): Actions[typeof ORDER_UPDATE_LOADING] => ({
    type: ORDER_UPDATE_LOADING, payload,
  }),
  orderUpdateCancel: (payload: boolean): Actions[typeof ORDER_UPDATE_CANCEL] => ({
    type: ORDER_UPDATE_CANCEL, payload,
  }),
  resinOrderUpdateStart: (payload: any): Actions[typeof RESIN_ORDER_UPDATE_START] => ({
    type: RESIN_ORDER_UPDATE_START, payload,
  }),
  resinOrderUpdateError: (payload: any): Actions[typeof RESIN_ORDER_UPDATE_ERROR] => ({
    type: RESIN_ORDER_UPDATE_ERROR, payload,
  }),
  resinOrderUpdateSuccess: (payload: any): Actions[typeof RESIN_ORDER_UPDATE_SUCCESS] => ({
    type: RESIN_ORDER_UPDATE_SUCCESS, payload,
  }),
  resinOrderUpdateLoading: (payload: boolean): Actions[typeof RESIN_ORDER_UPDATE_LOADING] => ({
    type: RESIN_ORDER_UPDATE_LOADING, payload,
  }),
  resinOrderUpdateCancel: (payload: boolean): Actions[typeof RESIN_ORDER_UPDATE_CANCEL] => ({
    type: RESIN_ORDER_UPDATE_CANCEL, payload,
  }),

  cancelStopAutoRenewStart: (payload: any): Actions[typeof CANCEL_STOP_AUTO_RENEW_START] => ({
    type: CANCEL_STOP_AUTO_RENEW_START,
    payload,
  }),
  cancelStopAutoRenewError: (payload: any): Actions[typeof CANCEL_STOP_AUTO_RENEW_ERROR] => ({
    type: CANCEL_STOP_AUTO_RENEW_ERROR,
    payload,
  }),
  cancelStopAutoRenewSuccess: (payload: any): Actions[typeof CANCEL_STOP_AUTO_RENEW_SUCCESS] => {
    return ({ type: CANCEL_STOP_AUTO_RENEW_SUCCESS, payload: payload});
  },
  cancelStopAutoRenewLoading: (payload: boolean): Actions[typeof CANCEL_STOP_AUTO_RENEW_LOADING] => ({
    type: CANCEL_STOP_AUTO_RENEW_LOADING,
    payload,
  }),
  cancelStopAutoRenewCancel: (payload: boolean): Actions[typeof CANCEL_STOP_AUTO_RENEW_CANCEL] => ({
    type: CANCEL_STOP_AUTO_RENEW_CANCEL,
    payload,
  }),

  resinOrderRefundStart: (payload: any): Actions[typeof RESIN_ORDER_REFUND_START] => ({
    type: RESIN_ORDER_REFUND_START, payload,
  }),
  resinOrderRefundError: (payload: any): Actions[typeof RESIN_ORDER_REFUND_ERROR] => ({
    type: RESIN_ORDER_REFUND_ERROR, payload,
  }),
  resinOrderRefundSuccess: (payload: any): Actions[typeof RESIN_ORDER_REFUND_SUCCESS] => ({
    type: RESIN_ORDER_REFUND_SUCCESS, payload,
  }),
  resinOrderRefundLoading: (payload: boolean): Actions[typeof RESIN_ORDER_REFUND_LOADING] => ({
    type: RESIN_ORDER_REFUND_LOADING, payload,
  }),
  resinOrderRefundCancel: (payload: boolean): Actions[typeof RESIN_ORDER_REFUND_CANCEL] => ({
    type: RESIN_ORDER_REFUND_CANCEL, payload,
  }),
};
